import { h } from 'preact';
import { VerifyContainer } from 'features/verify/ui/verify-container';
import { Spinner, SpinnerContainer } from 'ui/spinner';
import { Subtitle } from 'ui/typography';

export const NotReady = () => {
	return (
		<VerifyContainer>
			<SpinnerContainer>
				<Spinner
					size={84}
					fill={{
						primary: 'var(--primary-color)',
						secondary: 'var(--secondary-color)',
					}}
				/>
				<Subtitle
					style={{
						marginTop: 42,
						textAlign: 'center',
					}}
				>
					Putting everything together
				</Subtitle>
			</SpinnerContainer>
		</VerifyContainer>
	);
};
